module.exports = __webpack_public_path__ + "img/Spotify_Icon_RGB_Green.7a34cf42.png";